/* eslint-disable angular/file-name */
angular.module('zc.core')

  .component('zcBillingRepresentatives', {
    templateUrl: '/templates/core/components/billing_representatives/billing_representatives.html',
    bindings: {
      representatives: '=',
    },
    controller: billingRepresentatives,
    controllerAs: 'vm',
  });

billingRepresentatives.$inject = ['Devise'];
function billingRepresentatives(Devise) {
  const vm = this;
  const REPRESENTATIVE_LIMIT = 5;
  const REPRESENTATIVE_FIELDS = [
    'full_name',
    'email',
  ];

  function isRepresentativesObjectCompletelyEmpty() {
    // has more than one representative field
    if(vm.representatives.length > 1) {
      return false;
    }

    const theOnlyRepresentative = vm.representatives[0];
    const isAllFieldsEmpty = !_.some(theOnlyRepresentative);
    return isAllFieldsEmpty;
  }

  function isRepresentativeLimitReached() {
    return vm.representatives.length >= REPRESENTATIVE_LIMIT;
  }

  function addNewRepresentative(representativeIndex) {
    if(isRepresentativeLimitReached()) {
      return;
    }

    vm.representatives.push(_.zipObject(REPRESENTATIVE_FIELDS));
  }

  function removeRepresentative(representativeIndex) {
    const representative = vm.representatives[representativeIndex];
    if(!representative) {
      return;
    }

    if(vm.representatives.length === 1) {
      vm.representatives = [_.zipObject(REPRESENTATIVE_FIELDS)];
      return;
    }

    vm.representatives.splice(representativeIndex, 1);
  }

  vm.$onInit = () => {
    // Create empty representative object array
    // from representative fields if there's no representatives
    if(!vm.representatives || vm.representatives.length === 0) {
      vm.representatives = [_.zipObject(REPRESENTATIVE_FIELDS)];
    }

    vm.isRepresentativesObjectCompletelyEmpty = isRepresentativesObjectCompletelyEmpty;
    vm.isRepresentativeLimitReached = isRepresentativeLimitReached;
    vm.addNewRepresentative = addNewRepresentative;
    vm.removeRepresentative = removeRepresentative;
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/components/billing_representatives/billing_representatives.js